import { render } from "./HeroApprovalOvertimeModal.vue?vue&type=template&id=847ed6be&scoped=true"
import script from "./HeroApprovalOvertimeModal.vue?vue&type=script&lang=js"
export * from "./HeroApprovalOvertimeModal.vue?vue&type=script&lang=js"

import "./HeroApprovalOvertimeModal.vue?vue&type=style&index=0&id=847ed6be&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-847ed6be"]])

export default __exports__